import {PopupOverviewRestDto, PopupOverviewResultsRestDto} from "@/api/pharma-cms-popup/models";

export class PopupOverviewResultsRestDtoModel implements PopupOverviewResultsRestDto {
    results?: PopupOverviewRestDto[] | null;

    constructor(results: PopupOverviewRestDto[] | null) {
        this.results = results;
    }

    public static createWithDefaults(): PopupOverviewResultsRestDtoModel {
        return new this([]);
    }
}
